import React, { Fragment } from "react";

import { Col, Row } from "antd";
import { useNavigate } from "react-router-dom";

import Container from "@/components/container/Container";
import CardComponent from "@/components/card";

import IconPen from "@/components/icons/IconPen";
import IconUserProfile from "@/components/icons/IconUserProfile";

import "@/styles/pages/profile/profile.scss";
import { getUserInfo } from "@/reducers/commonSlice";
import { useSelector } from "react-redux";
import IconSchoolCollege from "@/components/icons/IconSchoolCollege";

const profile = {
  profileImgUrl: "/assets/images/profile.svg",
  firstName: "Roonie",
  lastName: "Shukla",
  role: "Mentor",
  profileMenus: [
    {
      path: "/profile/basic-contact-information",
      icon: <IconUserProfile />,
      profileMenu: "Profile Information",
      pen: <IconPen />,
    },
    {
      path: "/profile/advance-career-information",
      icon: <IconSchoolCollege />,
      profileMenu: "Career & Education",
      pen: <IconPen />,
    },
    {
      path: "/profile/basic-profile-detail",
      icon: <IconUserProfile />,
      profileMenu: "Guide Profile",
      pen: <IconPen />,
    },
    // {
    //   path: "/profile/basic-profile-detail",
    //   icon: <IconUserProfile />,
    //   profileMenu: "Guide Information",
    //   pen: <IconPen />,
    // },
  ],
};

const GuideProfilePanel = () => {
  const navigate = useNavigate();
  const userData = useSelector(getUserInfo);

  const gotoMenu = (path) => {
    navigate(path);
  };

  return (
    <Fragment>
      <div className="profile-page">
        <Container>
          <CardComponent>
            <div className="options-container">
              <Row>
                <Col xxl={24}>
                  <div className="heading">
                    <div className="title-h5-1">My Profile</div>
                  </div>
                </Col>
              </Row>

              <Row gutter={[24, 16]}>
                <Col xxl={3} xl={3} lg={6} md={24} sm={24} xs={24}>
                  <div className="info">
                    <CardComponent>
                      <div className="profile-picture">
                        <img
                          src={
                            userData.profileImgUrl
                              ? userData.profileImgUrl
                              : "/assets/images/defaultProfile.jpeg"
                          }
                          style={{ borderRadius: "50%" }}
                          alt="profile-picture"
                        />
                      </div>
                      <div className="profile-name">
                        <div className="name body-b1">
                          {userData?.user?.firstName} {userData?.user?.lastName}
                        </div>
                        <div className="role body-b5">{profile.role}</div>
                      </div>
                    </CardComponent>
                  </div>
                </Col>
                <Col xxl={21} xl={21} lg={18} md={24} sm={24} xs={24}>
                  <div className="options">
                    <Row gutter={[16, 24]}>
                      {profile?.profileMenus?.map((item, index) => {
                        return (
                          <Fragment key={index}>
                            <Col
                              xxl={8}
                              xl={8}
                              lg={12}
                              md={24}
                              sm={24}
                              xs={24}
                              key={index}
                              onClick={() => gotoMenu(item.path)}
                            >
                              <CardComponent>
                                <div className="option">
                                  <div className="option-content">
                                    <div className="icon">{item.icon}</div>
                                    <div className="option-name body-b3">{item.profileMenu}</div>
                                  </div>
                                  <div className="pen-icon">{item.pen}</div>
                                </div>
                              </CardComponent>
                            </Col>
                          </Fragment>
                        );
                      })}
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </CardComponent>
        </Container>
      </div>
    </Fragment>
  );
};

export default GuideProfilePanel;
